import EventEmitter from 'eventemitter3'
import NameSpace from '../ns/NameSpace'
import AssetsManager from '../data/AssetsManager'
import Loadingview from '../view/Loadingview'
import LocationUtil from '../util/LocationUtil'
import KvsManager from '../kvs/KvsManager'

/**
 * WORKS管理用クラス
 */
class WorksMananger extends EventEmitter
{

  // ---------------------------------------------------------------------------------------------------------
  // --	WorksMananger
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  constructor() {
    super();
    this.map = new Map()
  }

  // ---------------------------------------------------------------------------------------------------------
  // --	スタート
  // ---------------------------------------------------------------------------------------------------------

  start(worksModel, needClear = true)
  {
    console.log('WorksManager.start:', worksModel)

    //クリア（スタンプゲット）演出が必要かどうか
    this.needClear = needClear

    //モデル保持
    this.worksModel = worksModel

    //結果用配列をリセット
    this.results = []

    //移動コンテンツ（複数問）の場合
    if(this.worksModel.isMove)
    {
      //移動コンテンツ読み込み
      this.loadMoveWork()
    }
    //イベントコンテンツの場合
    else
    {
      //変数初期化
      this.worksNum = this.worksModel.works.length;
      this.workIndex = -1;

      //次のWork開始
      this.loadNextWork();
    }
  }

  // ---------------------------------------------------------------------------------------------------------
  // --	移動コンテンツ
  // ---------------------------------------------------------------------------------------------------------

  /**
   * 読み込み
   */
  async loadMoveWork()
  {
    //クラスを読み込み
    await this.loadClass(this.worksModel.moveClass)

    //Work生成
    const cls = this.getClass(this.worksModel.moveClass)
    this.work = new cls(this.worksModel.baseDir, this.worksModel.works, true)
    this.work.once('CLEAR', (results) => {
      this.results = results
      this.finish()
    })
  }


  // ---------------------------------------------------------------------------------------------------------
  // --	イベントコンテンツ
  // ---------------------------------------------------------------------------------------------------------

  /**
   * 次のワーク開始
   */
  async loadNextWork()
  {
    //インデックス変更
    this.workIndex ++

    console.log('loadNextWork:' + this.workIndex)

    //パス
    const workDir = this.worksModel.works[this.workIndex]

    //config.json読み込み
    await AssetsManager.loadConfig('work', workDir)

    //Workのクラス名
    const clsName = (AssetsManager.getConfig('work').type == 'move')?this.worksModel.moveClass:AssetsManager.getConfig('work').class
    console.log('clsName:' + clsName)

    //クラスを読み込み
    await this.loadClass(clsName)

    //Work生成
    const cls = this.getClass(clsName)
    if(AssetsManager.getConfig('work').type == 'event')
    {
      this.work = new cls(workDir)
    }
    else if(AssetsManager.getConfig('work').type == 'move')
    {
      this.work = new cls(this.worksModel.baseDir, [workDir])
    }
    this.work.once('CLEAR', this.onClear.bind(this))
  }


  // ---------------------------------------------------------------------------------------------------------
  // --	WORKクリア
  // ---------------------------------------------------------------------------------------------------------

  onClear(result)
  {
    //結果保存
    this.results.push(result)
    console.log(this.results)

    //全ワーク終了
    if(this.workIndex >= this.worksNum - 1)
    {
      this.finish()
    }
    //次のワークへ
    else
    {
      //ローディング表示
      Loadingview.show()

      //一瞬間を開ける
      TweenMax.delayedCall(0.1, ()=>
      {
        //今のワークをいったん破棄
        this.work.dispose()

        //次のワークを読み込み
        this.loadNextWork()
      })
    }
  }

  /**
   * 終了
   */
  finish()
  {
    //次への間
    let delay = 0

    //クリア演出表示
    if(this.needClear)
    {
      //個別のステージクリア演出
      if(this.worksModel.clear)
      {
        this.work.showFinish(this.worksModel.clear)
        delay = (this.worksModel.clear.time)?this.worksModel.clear.time:5
      }
      //共通のステージクリア演出
      else
      {
        this.work.showClear()
        delay = 4
      }
    }

    //間をおく
    TweenMax.delayedCall(delay, ()=>
    {
      //終了画面の表示
      if(this.worksModel.finish)
      {
        this.showFinish()
      }
      //普通に終了イベント発行
      else
      {
        this.emit('FINISH', this.results)
      }
    });
  }

  /**
   * 終了画面表示
   */
  showFinish()
  {
    //終了画面表示
    this.work.showFinish(this.worksModel.finish);

    //終了イベント発行までの待ち時間
    let delay = (this.worksModel.finish.time)?this.worksModel.finish.time:3

    //終了イベント発行
    gsap.delayedCall(delay, ()=>
    {
      this.emit('FINISH', this.results);
    });
  }

  
  // ---------------------------------------------------------------------------------------------------------
  // --	クラス管理
  // ---------------------------------------------------------------------------------------------------------

  /**
   * Classファイル読み込み
   */
  loadClass(type)
  {
    return new Promise((resolve, reject) =>
    {
      //クラスが読み込み済みの場合
      if(this.hasClass(type))
      {
        // console.log(type + 'クラス読み込み済み');
        resolve();
      }
      //クラスが読み込み済みではない場合
      else
      {
        // console.log(type + 'クラスはまだ読み込まれていませ');
        var scriptElement = document.createElement('script')
        scriptElement.src = LocationUtil.getAbsolutePath('/assets/js/' + type + '.js')
        // console.log('scriptElement.src:' + scriptElement.src)
        var headElement = document.getElementsByTagName('head')[0]
        headElement.appendChild(scriptElement)
        scriptElement.onload = (e) => {
          // console.log(type + 'クラス読み込み完了')
          resolve();
        }
      }
    })
  }

  /**
   * クラスを追加
   */
  addClass(key, cls)
  {
    this.map.set(key, cls);
  }

  /**
   * クラスが登録済みかどうかの判定
   */
  hasClass(key)
  {
    return this.map.has(key);
  }

  /**
   * クラス取得
   */
  getClass(key)
  {
    return this.map.get(key);
  }

  /**
   * クラス生成
   */
  newClass(key, path)
  {
    const cls = this.map.get(key);
    return new cls(path);
  }

  // ---------------------------------------------------------------------------------------------------------
	// --	破棄
  // ---------------------------------------------------------------------------------------------------------

  dispose()
  {
    this.work.off('CLEAR')
    this.work.dispose()
    this.work = null
  }
  
  // ---------------------------------------------------------------------------------------------------------
}

if(!NameSpace.getNameSpace('okawari.common.data').WorksMananger)
  NameSpace.getNameSpace('okawari.common.data').WorksMananger = new WorksMananger();
export default NameSpace.getNameSpace('okawari.common.data').WorksMananger;